
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class OsQuestionnairePage extends Vue {
  @Prop({ required: false, default: undefined })
  progress!: number;
}
